import { gql } from '@apollo/client';
const ASSIGN_TEMPLATE_ELEMENT = gql `
  mutation AssignTemplateElement($templateId: ID!, $elementId: ID!) {
    assignModelSpecificationTemplateElement(templateId: $templateId, elementId: $elementId) {
      assignedTemplateElement {
        id
        element {
          id
          name
        }
      }
    }
  }
`;
export default ASSIGN_TEMPLATE_ELEMENT;
